/*
CUSTOMIZATIONS:
- aggiunta la prop 'title_type' e 'title_id' e 'id' al componente Gallery per fare in modo che il titolo appaia nella sidebar della notizia
*/

import React from 'react';
import PropTypes from 'prop-types';

import { Gallery } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const NewsItemGallery = ({ content }) => {
  return (
    <Gallery
      content={content}
      folder_name={'multimedia'}
      title_type="h2"
      title_id="header-galleria"
      id="galleria"
    />
  );
};

NewsItemGallery.propTypes = {
  content: PropTypes.object.isRequired,
};

export default NewsItemGallery;
